import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./notFound.module.css";
import logoDark from "../../Images/logo 3.svg";

function NotFound() {
  const navigate = useNavigate();
  // react-router keeps the in-app history index here; 0 means the guest
  // landed on this page directly and "back" would leave the site
  const canGoBack = window.history.state?.idx > 0;

  return (
    <div className={styles.notFoundPage}>
      <header className={styles.notFoundHeader}>
        <Link to="/" aria-label="PosEase home">
          <img src={logoDark} alt="PosEase" className={styles.notFoundLogo} />
        </Link>
      </header>

      <main className={styles.notFoundMain}>
        <div className={styles.notFoundCard}>
          <span className={styles.notFoundIcon} aria-hidden="true">
            <i className="fa-solid fa-door-closed"></i>
          </span>
          <p className={styles.notFoundCode}>Error 404</p>
          <h1 className={styles.notFoundTitle}>Page not found</h1>
          <p className={styles.notFoundText}>
            The page you're looking for doesn't exist, or the link may be
            incomplete. Open the booking link from your hotel again, or find
            your hotel from the home page.
          </p>
          <div className={styles.notFoundActions}>
            <Link to="/" className={styles.notFoundPrimary}>
              <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
              Find your hotel
            </Link>
            {canGoBack && (
              <button
                type="button"
                className={styles.notFoundSecondary}
                onClick={() => navigate(-1)}
              >
                <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
                Go back
              </button>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
export default NotFound;
